import React from "react";
import { Input } from "antd";
import { SearchOutlined } from '@ant-design/icons';
const { Search } = Input;


const CustomSearch = ({ onSearch, onChange }) => {


  const handleSearch = (value, event) => {
    event?.preventDefault?.();
    onSearch(value);
  };

  return (

    <Search
      placeholder="Search..."
      onSearch={handleSearch}
      onChange={onChange ? (e) => onChange(e.target.value) : undefined}
      enterButton={< SearchOutlined  className="text-xl mb-1"/>}
      allowClear
      />
  );
};

export default CustomSearch;

